import { Box, Grid, Theme, Typography } from '@mui/material';
import sanitizeHtml from 'sanitize-html';
import he from 'he';
import { SxClassProps } from '@/types/common';
import { useHeroContent } from './HeroContentContext';
import { ZipCodeCTA } from './ZipCodeCTA';
import JobHeroCTA from './JobHeroCTA';

const classes: SxClassProps = {
  container: {
    paddingX: {
      xs: 3,
    },
    marginLeft: {
      sm: 5,
      md: 10,
      xl: 'calc((100vw - 1440px) / 2 + 80px)',
    },
    paddingY: {
      sm: 5,
    },
  },
  containerJobs: {
    paddingX: {
      xs: 3,
    },
    marginLeft: {
      sm: 5,
      md: 6,
      xl: 'calc((100vw - 1440px) / 2 + 80px)',
    },
    paddingY: {
      sm: 12,
    },
  },
  content: {
    minWidth: {
      md: '490px',
    },
    maxWidth: {
      sm: '450px',
      md: '590px',
      lg: '650px',
    },
    backgroundColor: 'rgb(255, 255, 255, 0.9)',
    padding: {
      sm: 3,
      md: 5,
    },
    borderRadius: '16px',
  },
  contentJobs: {
    minWidth: {
      md: '400px',
    },
    maxWidth: {
      sm: '400px',
      md: '450px',
      lg: '540px',
    },
    backgroundColor: 'rgb(255, 255, 255, 0.9)',
    padding: {
      sm: 3,
      md: 5,
    },
    borderRadius: '16px',
  },
  headline: (theme: Theme) => ({
    fontWeight: 700,
    fontSize: {
      xs: theme.typography.h1.fontSize,
      lg: theme.typography.display2.fontSize,
    },
    lineHeight: {
      xs: theme.typography.h1.lineHeight,
      lg: theme.typography.display2.lineHeight,
    },
    m: 0,
    pb: 2,
  }),
  subHeadline: (theme: Theme) => ({
    fontWeight: 400,
    fontSize: {
      xs: theme.typography.body1.fontSize,
      lg: theme.typography.h2.fontSize,
    },
    lineHeight: {
      xs: theme.typography.body1.lineHeight,
      lg: '28px',
    },
    pb: {
      xs: 3,
      md: 4,
    },
    '& p': {
      m: 0,
    },
  }),
};

const HeroContentCard = () => {
  const { headline, subHeadline, isJobSegment } = useHeroContent();

  return (
    <Grid item xs={12} sx={isJobSegment ? classes.containerJobs : classes.container}>
      <Box sx={isJobSegment ? classes.contentJobs : classes.content}>
        <Typography
          variant="h1"
          color="primary"
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(he.decode(headline)),
          }}
          sx={classes.headline}
        />
        <Box
          sx={classes.subHeadline}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(he.decode(subHeadline)),
          }}
        />
        {!isJobSegment && <ZipCodeCTA />}
        {isJobSegment && <JobHeroCTA />}
      </Box>
    </Grid>
  );
};

export { HeroContentCard };
